import { Autocomplete, FormHelperText, Grid, TextField, Tooltip } from "@mui/material";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { DeleteButtonIcon, FaceBookIcon, InfoIcon, LiveChatByFalkonSystemsIcon, LiveChatMinimizeIcon, MessageDeliveredIcon, WhatsAppIcon } from "../../icon";
import ButtonComponent from "../shared/button/button.component";
import Avatar from "../shared/avatar.component";
import { ChannelType } from "../../models/conversations";
import { ChannelAccountModel, VisitorLoginType, WidgetTitle } from "../../models/channels/channels.model";
import { ChannelUserModel, mapToChannelUser } from "../../models/users.model";
import { LiveChatService } from "../../services/channels/LiveChatService";
import { LoadChannels } from "../../actions";
import { ChannelUserService } from "../../services/ChannelUserService";
import { useDispatch, useSelector } from "react-redux";
import setToast from "../../helpers/toaster.helper";
import { ToasterType } from "../shared/toaster/toaster.model";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../routes/route.path";
import * as selector from '../../selectors/selectors';


interface IProps {
    Edit?: boolean;
    WidgetColor?: string;
    Title?: string;
    Icon?: string;
    HandleNext?: (x?: any) => void;
    StepData?: any;
    Channel?: ChannelAccountModel;
    HandleBack?: (x?: any) => void;
}


const VisitorDetailsComponent: React.FC<IProps> = (props: IProps) => {

    const dispatch = useDispatch()
    const navigate = useNavigate();
    const Channels: ChannelAccountModel[] = useSelector(selector.Channels)
    const IsWordPress: boolean = useSelector(selector.IsWordpress)


    const visitorTypeOptions = [{ Name: "Let visitors choose how to start", Value: 1, InfoMessage: "Let visitors start chatting right away or share their details for better support and follow-up. This usually leads to higher engagement." }, { Name: "Start chat after form submission", Value: 2, InfoMessage: "Require visitors to share their form details before starting the chat, so you always have contact details for follow-up." }, { Name: "Instant chat (Guest)", Value: 3, InfoMessage: "Visitors can start chatting instantly without sharing any form details. Best for quick questions and faster engagement." }]

    const anonymousSessionsOptions = [{ Name: "30_Min", Selected: true, Label: "30 Min" }, { Name: "1_Hour", Selected: false, Label: "1 Hour" }, { Name: "3_Hour", Selected: false, Label: "3 Hour" }, { Name: "6_Hour", Selected: false, Label: "6 Hour" }, { Name: "24_Hour", Selected: false, Label: "24 Hour" }, { Name: "Never", Selected: false, Label: "never" }]

    const [widgetLoginType, setWidgetLoginType] = useState<number>(props.StepData?.VisitorLoginType || props.Channel?.PremiumFeatures.VisitorLoginType || 1)
    const [anonymousSessions, setAnonymousSessions] = useState<any[]>(anonymousSessionsOptions.map(x => ({ ...x, Selected: !!props.Channel ? x.Name === props.Channel?.PremiumFeatures?.AnonymousUserSettings : x.Selected })))
    const [LoggedinUserFeilds, setLoggedinUserFields] = useState<{ Id: number, Name: string, Type: "Text" | "Number" | "", Required: "Yes" | "No" | "", Error: string }[]>(props.StepData?.LoginFields || props?.Channel?.PremiumFeatures?.LoginFields || [])

    const [socialIntegrations, setSocialIntegrations] = useState({ facebookUrl: props.Channel?.PremiumFeatures?.Channels.find(x => x.ChannelType === 1)?.URL || "", whatsappUrl: props.Channel?.PremiumFeatures?.Channels.find(x => x.ChannelType === 3)?.URL || "" })
    const [isLoading, setIsloading] = useState<boolean>(false)


    const user = mapToChannelUser(JSON.parse(localStorage.getItem("current-user"))) as ChannelUserModel;

    useEffect(() => {
        if (props?.StepData?.Channels || props?.StepData?.AnonymousUserSettings) {
            setSocialIntegrations({ facebookUrl: props.StepData?.Channels?.find(x => x.ChannelType === 1)?.URL || "", whatsappUrl: props.StepData?.Channels.find(x => x.ChannelType === 3)?.URL || "" })
            setAnonymousSessions(anonymousSessionsOptions.map(x => ({ ...x, Selected: x.Name === props.StepData?.AnonymousUserSettings })))
        }
    }, [props.StepData])

    useLayoutEffect(() => {
        if (!Channels?.length) {
            LoadChannels(dispatch, user.OrganizationID)
        }
    }, [])


    const handleAnonymousSession = (name: string) => {
        setAnonymousSessions(anonymousSessions.map(x => { return { ...x, Selected: x.Name === name ? true : false } }))
    }

    const addField = () => {
        setLoggedinUserFields([...LoggedinUserFeilds, { Id: new Date().valueOf(), Name: "", Type: "", Required: "", Error: "" }])
    }

    const removeFeild = (id: number) => {
        setLoggedinUserFields(LoggedinUserFeilds.filter(x => x.Id !== id))
    }

    const handleAddFieldName = (e, id: number) => {
        setLoggedinUserFields(LoggedinUserFeilds.map(x => x.Id === id ? { ...x, Name: e.target.value?.slice(0, 15), Error: (x.Type !== "" && x.Required !== "" && e.target.value !== "") ? "" : "one or more feilds are empty" } : x))
    }

    const handleAddFieldType = (value, id: number) => {
        setLoggedinUserFields(LoggedinUserFeilds.map(x => x.Id === id ? { ...x, Type: value, Error: (x.Required !== "" && x.Name !== "") ? "" : "one or more feilds are empty" } : x))

    }

    const handleAddFieldRequired = (value, id: number) => {
        setLoggedinUserFields(LoggedinUserFeilds.map(x => x.Id === id ? { ...x, Required: value, Error: (x.Type !== "" && x.Name !== "") ? "" : "one or more feilds are empty" } : x))

    }

    const handleBack = () => {
        props.HandleBack({
            VisitorLoginType: widgetLoginType,
            AnonymousUserSettings: anonymousSessions.find(x => x.Selected)?.Name,
            LoginFields: LoggedinUserFeilds.map((x, index) => { return { Name: x.Name, Type: x.Type, Required: x.Required, Id: index } }),
            IsAllowFalkonBranding: props.StepData?.IsAllowFalkonBranding,
            IsShowRating: props.StepData?.IsShowRating,
            Channels: [{ ChannelType: 1, URL: socialIntegrations.facebookUrl }, { ChannelType: 3, URL: socialIntegrations.whatsappUrl }]
        });
    }

    const handleNext = () => {
        const data = LoggedinUserFeilds.map(x => (x.Name === "" || x.Required === "" || x.Type === "") ? { ...x, Error: "one or more feilds are empty" } : x)

        if (data.find(x => x.Error)) {
            setLoggedinUserFields(data)
            return
        }

        let logodata = { file_name: props.StepData?.MediaUrl?.includes("s3.us-central-1.wasabisys.com") ? "" : props.StepData?.MediaName, value: props.StepData?.MediaUrl?.includes("s3.us-central-1.wasabisys.com") ? props.StepData?.MediaUrl : props.StepData?.MediaUrl?.split(',')[1] } as any
        let formData = {
            "name": props.StepData.WidgetTitle,
            "welcome_message": props.StepData.WelcomeMessage,
            "welcome_message_status": props.StepData.WelcomeMessageStatus,
            "widget_type": props?.StepData?.WidgetTitleType,
            "widget_color": props?.StepData?.WidgetColor,
            "text_color": props?.StepData?.HeaderTextColor,
            "visitor_login_Type": widgetLoginType,
            "anonymous_user_settings": widgetLoginType === VisitorLoginType.ALLOW_LOGIN_ONLY ? "" : anonymousSessions.find(x => x.Selected)?.Name,
            "login_fields": widgetLoginType === VisitorLoginType.ALLOW_LOGIN_ONLY ? [] : LoggedinUserFeilds.map(x => { return { field_name: x.Name, field_type: x.Type, isRequired: x.Required === "Yes" ? true : false } }),
            "channels": [{ channel_type: 1, url: socialIntegrations.facebookUrl }, { channel_type: 3, url: socialIntegrations.whatsappUrl }],
            "isAllowFalkonBranding": props.StepData?.IsAllowFalkonBranding,
            "isIncludeQuestionnaire": props.StepData?.IsShowRating,
            "channel_logo": logodata
        }
        setIsloading(true)
        if (!!props.Channel) {
            LiveChatService.EditLiveChatChannel(user.OrganizationID, props.Channel.ID, formData).then((res) => {
                setToast(`${props.StepData.WidgetTitle} has been updated Sucessfully!`, ToasterType.SUCCESS, "default")
                setIsloading(false)
                LoadChannels(dispatch, ChannelUserService.getCurrentUserFromLocalStorage().OrganizationID)
                navigate(AppRoutes.CHANNELS)
            }).catch((err) => {
                if (err.response.data === "unsupported file type") {
                    setToast("unsupported file type", ToasterType.DANGER, "default")
                    setIsloading(false)
                }
            })
        }
        else {
            LiveChatService.CreateLiveChatChannel(user.OrganizationID, ChannelType.LIVE_CHAT, formData).then((res) => {
                LoadChannels(dispatch, ChannelUserService.getCurrentUserFromLocalStorage().OrganizationID)
                props.HandleNext({
                    ChannelID: res.data.created_channel_accounts[0],
                    VisitorLoginType: widgetLoginType,
                    AnonymousUserSettings: anonymousSessions.find(x => x.Selected)?.Name,
                    LoginFields: LoggedinUserFeilds.map((x, index) => { return { Name: x.Name, Type: x.Type, Required: x.Required, Id: index } }),
                    IsAllowFalkonBranding: props.StepData?.IsAllowFalkonBranding,
                    IsShowRating: props.StepData?.IsShowRating,
                    Channels: [{ channel_type: 1, url: socialIntegrations.facebookUrl }, { channel_type: 3, url: socialIntegrations.whatsappUrl }]
                })
                setIsloading(false)
            }).catch(err => { setIsloading(false) })
        }
    }

    const handleVisitorChange = (value) => {
        setWidgetLoginType(value);
    };

    return (
        <div className="add-phone-number-paper-border paper-background h-p-100 m-auto br-2 d-flex flex-direction justify-center align-center">
            <div className="h-p-100 w-p-100 d-flex">
                <div className="w-p-54 d-flex flex-direction o-y-scroll">
                    {!props.Edit &&
                        <div className="min-h-6 w-p-94 h2-semibold d-flex align-end ml-2">
                            Set Up Visitor Interaction Information
                        </div>
                    }
                    <div className={`${!props.Edit ? "min-h-8" : "min-h-12"} w-p-100`}>
                        <div className="h-p-40 w-p-94 mx-2 d-flex  h5-semibold align-end">
                            How should visitors start a chat?
                        </div>
                        <div className="h-p-60 w-p-90 ml-2">
                            {visitorTypeOptions.map(x => <div className="d-flex my-1">
                                <div className="box-shadow-channel bg-color-secondary br-p-50 d-flex justify-center align-center c-pointer" onClick={() => { handleVisitorChange(x.Value) }} style={{ width: "20px", height: "20px" }}>
                                    {x.Value === widgetLoginType && <div className="br-p-50 bg-color-primary-light" style={{ width: "12px", height: "12px" }}></div>}
                                </div>
                                <span className={`h4-regular color-primary-accent ml-1`}>{x.Name}</span>
                                <span className="d-flex align-center ml-1 c-pointer">
                                    <Tooltip title={x.InfoMessage} placement='top'><InfoIcon /></Tooltip></span>
                            </div >
                            )}
                        </div>
                    </div>

                    <div className={`w-p-100 mt-2`}>
                        <div className="w-p-94 mx-2 d-flex h5-semibold align-end min-h-4">
                            Visitor Session Duration
                        </div>
                        <Grid container className="w-p-94 mx-2 mb-1">
                            {anonymousSessions.map(x => {
                                return < Grid item xs={12} md={12} sm={12} lg={6} xl={4}>
                                    <div className={" d-flex font-bold w-p-100 mt-1"}>
                                        <div className="box-shadow-channel bg-color-secondary br-p-50 d-flex justify-center align-center c-pointer" onClick={() => { handleAnonymousSession(x.Name) }} style={{ width: "20px", height: "20px" }}>
                                            {x.Selected && <div className="br-p-50 bg-color-primary-light" style={{ width: "12px", height: "12px" }}></div>}
                                        </div>
                                        <span className={`my-auto h4-regular color-primary-accent ml-1`}>{x.Label}</span>
                                    </div>
                                </Grid>
                            })}
                        </Grid>
                    </div>

                    {widgetLoginType !== VisitorLoginType.ALLOW_ANONYMOUS_LOGIN_ONLY && <div className={`w-p-100 mt-1`}>
                        <div className="w-p-94 mx-2 d-flex h5-semibold align-end min-h-4">
                            <div className="mr-auto">Login Form</div>
                            <div className="ml-auto color-primary-light c-pointer" onClick={addField}>Add Field +</div>
                        </div>
                        <div className="w-p-100 d-flex w-p-94">
                            <TextField
                                size="small"
                                variant="outlined"
                                placeholder="Field Name"
                                className=" bg-color-secondary w-p-46 ml-2 min-w-13 br-1 min-h-4 pt-1"
                                value={"Name"}
                                InputProps={{ classes: { input: 'h4-regular' } }}
                                disabled
                            />
                            <TextField
                                size="small"
                                variant="outlined"
                                placeholder="Field Name"
                                className=" bg-color-secondary w-p-46 ml-2 min-w-13 br-1 min-h-4 pt-1"
                                value={"Email"}
                                InputProps={{ classes: { input: 'h4-regular' } }}
                                disabled
                            />
                        </div>
                        {LoggedinUserFeilds.map(x => {
                            return (
                                <div className="w-p-94 mx-2">
                                    <div className="w-p-100 min-h-8 min-w-54 bg-color-select-widget-color mt-1 d-flex align-center br-2 live-chat-login-field">
                                        <TextField
                                            size="small"
                                            variant="standard"
                                            placeholder="Field Name"
                                            onChange={(e) => { handleAddFieldName(e, x.Id) }}
                                            className=" bg-color-secondary pl-2 w-p-30 ml-2 min-w-13 br-1 min-h-4 pt-1"
                                            value={x.Name}
                                        />
                                        <Autocomplete
                                            className="ml-2 w-p-30 mr-2 min-w-13 br-1"
                                            disableClearable
                                            size="small"
                                            classes={{ input: 'h4-regular', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                            options={["Text", "Number"]}
                                            getOptionLabel={(option: any) => option}
                                            onChange={(e, value) => { handleAddFieldType(value, x.Id) }}
                                            value={x.Type}
                                            renderInput={(params) =>
                                                <TextField {...params} size="small" variant="standard" placeholder="Field Type" onKeyDown={(e) => { e.preventDefault(); }} className="bg-color-secondary pl-2 min-h-4 pt-1 br-1 pr-1" />}
                                        />
                                        <Autocomplete
                                            className="ml-2 mr-3 min-w-13 br-1"
                                            disableClearable
                                            size="small"
                                            classes={{ input: 'h4-regular', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                            options={["Yes", "No"]}
                                            getOptionLabel={(option: any) => option}
                                            onChange={(e, value) => { handleAddFieldRequired(value, x.Id) }}
                                            value={x.Required}
                                            renderInput={(params) =>
                                                <TextField {...params} size="small" variant="standard" placeholder="Required" onKeyDown={(e) => { e.preventDefault(); }} className="bg-color-secondary pl-2 min-h-4 pt-1 br-1 pr-1" />}
                                        />
                                        <DeleteButtonIcon className="min-w-3 min-h-3 mx-auto c-pointer" onClick={() => removeFeild(x.Id)} />
                                    </div>
                                    <FormHelperText className="h6-regular color-primary-danger t-align-right ">
                                        {x.Error}
                                    </FormHelperText>
                                </div>
                            )
                        })}
                    </div>
                    }
                    <div className={`w-p-100 mt-auto`}>
                        {/* <div className="w-p-94 mx-2 d-flex h5-semibold align-end min-h-4">
                            Channel
                        </div>
                        <div className="d-flex w-p-94 mx-2 justify-between align-center mt-1">
                            <FaceBookIcon width={30} height={30} />
                            <Autocomplete
                                className="ml-2 w-p-85"
                                disableClearable
                                size="small"
                                classes={{ input: 'h4-regular', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                options={Channels.filter(x => x.ChannelType === ChannelType.FACEBOOK).map(x => x.ChannelRedirectUrl)?.filter(x => x !== socialIntegrations?.facebookUrl)}
                                onChange={(e, value) => { setSocialIntegrations({ ...socialIntegrations, facebookUrl: value }) }}
                                value={socialIntegrations?.facebookUrl || ""}
                                renderInput={(params) =>
                                    <TextField {...params} size="small" variant="outlined" placeholder="Select Url" name="Select url" onKeyDown={(e) => { e.preventDefault(); }} />}
                                renderOption={(defaultprops, option: any) => (
                                    <li {...defaultprops} >
                                        {
                                            <div className={" c-pointer h4-regular color-menu-list-font-color d-flex justify-between w-p-92"}>
                                                {option?.Name}
                                            </div>
                                        }
                                    </li>
                                )}
                            />
                        </div>
                        <div className="d-flex w-p-94 mx-2 justify-between align-center mt-2">
                            <WhatsAppIcon width={30} height={30} />
                            <Autocomplete
                                className="ml-2 w-p-85"
                                disableClearable
                                size="small"
                                classes={{ input: 'h4-regular', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                options={Channels.filter(x => x.ChannelType === ChannelType.WHATSAPP).map(x => x.ChannelRedirectUrl)?.filter(x => x !== socialIntegrations?.whatsappUrl)}
                                onChange={(e, value) => { setSocialIntegrations({ ...socialIntegrations, whatsappUrl: value }) }}
                                value={socialIntegrations?.whatsappUrl || ""}
                                renderInput={(params) =>
                                    <TextField {...params} size="small" variant="outlined" placeholder="Select Url" name="Select url" onKeyDown={(e) => { e.preventDefault(); }} />}
                                renderOption={(defaultprops, option: any) => (
                                    <li {...defaultprops} >
                                        {
                                            <div className={" c-pointer h4-regular color-menu-list-font-color d-flex justify-between w-p-92"}>
                                                {option?.Name}
                                            </div>
                                        }
                                    </li>
                                )}
                            />
                        </div> */}
                        <div className="d-flex w-p-94 mx-2 min-h-6 align-center pb-4 justify-between">
                            <ButtonComponent ButtonLabel={"Back"} Variant={"primary-btn"} ClassName="h-p-70" OnClick={() => { handleBack() }} />
                            <ButtonComponent ButtonLabel={props.Edit ? "Save" : "Next"} Variant={"primary-btn"} ClassName="h-p-70" OnClick={() => { handleNext() }} Loading={isLoading} />
                        </div>
                    </div>

                </div>
                <div className="w-p-44 h-p-100 mr-2">
                    {!props.Edit &&
                        <div className={`${IsWordPress ? "h-p-5" : "h-p-8"}  w-p-90 mx-auto d-flex align-end h5-semibold`}>
                            Live Chat Preview
                        </div>
                    }
                    <div className={`${IsWordPress ? "h-p-95" : "h-p-90"} w-p-90 m-auto d-flex align-center justify-center`}>
                        <div className={`${props.Edit ? "" : "add-phone-number-paper-border"} h-p-96 w-p-100 br-2 d-flex justify-center align-center`}>
                            <div className=" o-hidden br-2 d-flex flex-direction" style={{ boxShadow: "0px 12px 35px #4746464D", width: "300px", height: IsWordPress ? "405px" : "435px" }}>
                                <div className={`min-h-7 w-p-100 d-flex flex-direction ${props.StepData?.HeaderTextColor === "#ODODOD" ? "color-primary-accent" : "color-secondary"}`} style={{ background: props.StepData.WidgetColor }}>
                                    <div className="d-flex w-p-100 min-h-7 align-center">
                                        {props.StepData.WidgetTitleType === WidgetTitle.NAME_AND_LOGO && <div className={`w-p-20 d-flex justify-center align-center`}>
                                            <Avatar ImgSrc={(!!props.StepData?.MediaUrl && props.StepData.WidgetTitleType === WidgetTitle.NAME_AND_LOGO) ? props.StepData?.MediaUrl : ""} Name={props.StepData.WidgetTitle || ""} className={` d-flex justify-center align-center`} Size={36} />
                                        </div >
                                        }
                                        <div className={` ${props.StepData.WidgetTitleType === WidgetTitle.NAME_AND_LOGO ? "w-p-60" : "w-p-80 pl-2"} d-flex justify-center flex-direction`}>
                                            <div className={`w-p-100  d-flex align-center r-h2-regular`}>
                                                {props.StepData.WidgetTitle ? `${props.StepData.WidgetTitle.length > 18 ? props.StepData.WidgetTitle.slice(0, 15) + "..." : props.StepData.WidgetTitle}` : ""}
                                            </div>
                                            <div className={`br-2 d-flex align-center r-footnote`}>
                                                <MessageDeliveredIcon className={"mr-1"} />
                                                Online
                                            </div>
                                        </div >
                                        <div className={`w-p-10 d-flex justify-center align-center`}>
                                            <LiveChatMinimizeIcon width={20} height={20} />
                                        </div>
                                    </div>
                                    {/* {props.StepData?.PremiumFeatures &&
                                        <div className="d-flex align-center min-h-4">
                                            <div className="ml-2 r-h6-medium">Connect with</div>
                                            <FaceBookIcon width={20} height={20} className="mx-1" />
                                            <WhatsAppIcon />
                                        </div>
                                    } */}
                                    <div className="w-p-100 h-2">
                                        <div className="w-p-100 h-p-100 bg-color-live-chat-widget-hist-background" style={{ borderRadius: "50px 50px 0 0" }}></div>
                                    </div>
                                </div >
                                <div className={`min-h-20 bg-color-live-chat-widget-hist-background o-hidden flex-1 p-relative`}>
                                    {widgetLoginType !== VisitorLoginType.ALLOW_ANONYMOUS_LOGIN_ONLY &&
                                        <div className={`w-p-100 h-p-100 d-flex flex-direction align-center justify-center o-y-scroll`}>
                                            <div className="w-p-100 content-color h-p-94"  >
                                                {props.StepData?.WelcomeMessage &&
                                                    <div className={`d-flex ml-2 align-end`}>
                                                        {props.StepData.WidgetTitleType === WidgetTitle.NAME_AND_LOGO && <div className={` d-flex justify-end `}>
                                                            <div className={`w-p-100 d-flex justify-center align-center`}>
                                                                <Avatar ImgSrc={(!!props.StepData?.MediaUrl && props.StepData.WidgetTitleType === WidgetTitle.NAME_AND_LOGO) ? props.StepData?.MediaUrl : ""} Name={props.StepData.WidgetTitle || ""} className={` d-flex justify-center align-center`} Size={30} />
                                                            </div>
                                                        </div>
                                                        }
                                                        <div className="live-chat-inboundmsg bg-color-secondary h5-medium t-align-left float-left p-1 mt-2 ml-1 w-p-60 w-break w-fill">
                                                            {props.StepData?.WelcomeMessage}
                                                        </div>
                                                    </div>
                                                }
                                                <div className={`mx-auto br-3 live-chat-button d-flex flex-direction  ${!!LoggedinUserFeilds?.length && widgetLoginType === VisitorLoginType.ALLOW_LOGIN_ONLY ? "" : "justify-between"} bg-color-secondary py-2 px-2 mt-2 w-p-70`}>
                                                    <div className={` max-h-6 min-h-1 r-h5-regular   mx-auto color-primary-accent w-p-100 d-flex align-center`}>
                                                        Name*
                                                    </div>
                                                    <TextField className={` max-h-6 min-h-3 bg-color-secondary br-1 d-flex justify-center w-p-100`}
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                '& fieldset': {
                                                                    border: '2px solid #E9E9E9',
                                                                },
                                                            }
                                                        }}
                                                        placeholder="Name*"
                                                        value={""}
                                                        size={"small"}
                                                        onChange={() => { }}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: "#013EEF",
                                                                textAlign: "center"
                                                            }
                                                        }}
                                                        InputProps={{
                                                            classes: { input: "r-h4-regular" }
                                                        }}
                                                    />
                                                    <FormHelperText className={` max-h-1 min-h-1 m-0 color-primary-danger t-align-right mx-auto r-h6-regular w-p-100`}>
                                                        { }
                                                    </FormHelperText>
                                                    <div className={` max-h-6 min-h-1 r-h5-regular   mx-auto color-primary-accent w-p-100 d-flex align-center`}>
                                                        Email*
                                                    </div>
                                                    <TextField className={` max-h-6 min-h-1 bg-color-secondary br-1 d-flex justify-center m-0 w-p-100`}
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                '& fieldset': {
                                                                    border: '2px solid #E9E9E9',
                                                                },
                                                            }
                                                        }}
                                                        placeholder="Example@mail.in*"
                                                        value={""}
                                                        size={"small"}
                                                        onChange={() => { }}
                                                        InputProps={{
                                                            classes: { input: "r-h4-regular" }
                                                        }}
                                                    />
                                                    <FormHelperText className={` max-h-1 min-h-1 m-0 color-primary-danger t-align-right mx-auto r-h6-regular w-p-100`}>
                                                        {""}
                                                    </FormHelperText>
                                                    {
                                                        LoggedinUserFeilds.map(x => {
                                                            return (
                                                                x.Name === "Text" ?
                                                                    <>
                                                                        <div className={` max-h-6 min-h-1 r-h5-regular   mx-auto color-primary-accent w-p-100 d-flex align-center`}>
                                                                            {x.Name}{x.Required === "Yes" ? "*" : ""}
                                                                        </div>
                                                                        <TextField className={` max-h-6 min-h-1 bg-color-secondary br-1 d-flex justify-center m-0 w-p-100`}
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-root': {
                                                                                    '& fieldset': {
                                                                                        border: '2px solid #E9E9E9',
                                                                                    },
                                                                                }
                                                                            }}
                                                                            placeholder={`Enter ${x.Name}`}
                                                                            value={""}
                                                                            size={"small"}
                                                                            InputProps={{
                                                                                classes: { input: "r-h4-regular" }
                                                                            }}
                                                                            type="text"
                                                                            onChange={(e) => { }}
                                                                        />
                                                                        <FormHelperText className={` max-h-1 min-h-1 m-0 color-primary-danger t-align-right mx-auto r-h6-regular w-p-100`}>
                                                                            {""}
                                                                        </FormHelperText>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <div className={` max-h-6 min-h-1 r-h5-regular   mx-auto color-primary-accent w-p-100 d-flex align-center`}>
                                                                            {x.Name}{x.Required === "Yes" ? "*" : ""}
                                                                        </div>
                                                                        <TextField className={` max-h-6 min-h-1 bg-color-secondary br-1 d-flex justify-center m-0 w-p-100`}
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-root': {
                                                                                    '& fieldset': {
                                                                                        border: '2px solid #E9E9E9',
                                                                                    },
                                                                                }
                                                                            }}
                                                                            placeholder={`Enter ${x.Name}`}
                                                                            value={""}
                                                                            size={"small"}
                                                                            InputProps={{
                                                                                classes: { input: "r-h4-regular" }
                                                                            }}
                                                                            type="number"
                                                                            onChange={(e) => { }}
                                                                        />
                                                                        <FormHelperText className={` max-h-1 min-h-1 m-0 color-primary-danger t-align-right mx-auto r-h6-regular w-p-100`}>
                                                                            {""}
                                                                        </FormHelperText>
                                                                    </>
                                                            )
                                                        })
                                                    }
                                                    <div className={`min-h-5 max-h-5 box-shadow-live-chat-input live-chat-anonymous br-1 color-secondary  d-flex justify-center align-center c-pointer mt-1`} onClick={() => { }} style={{ background: props?.StepData?.WidgetColor }}>Chat</div>
                                                    {widgetLoginType === VisitorLoginType.ALLOW_LOGIN_AND_ANONYMOUS_LOGIN &&
                                                        <>
                                                            {widgetLoginType === VisitorLoginType.ALLOW_LOGIN_AND_ANONYMOUS_LOGIN && <div className={`min-h-5 max-h-5 color-live-chat-anonymous h6-medium text-between-line br-1 d-flex justify-center align-center c-pointer`}>or</div>}
                                                            <div className={`min-h-2 max-h-2 color-live-chat-anonymous br-1 f-link-hover h5-medium d-flex justify-center align-center c-pointer`} >
                                                                Continue as Guest
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {widgetLoginType === VisitorLoginType.ALLOW_ANONYMOUS_LOGIN_ONLY &&
                                        <div className={`w-p-100 mx-auto live-chat-button d-flex flex-direction justify-between`}>
                                            <div className={`bg-color-live-chat-widget-hist-background`}>
                                                <div className=" d-flex ml-2 align-end">
                                                    {props.StepData.WidgetTitleType === WidgetTitle.NAME_AND_LOGO && <div className={` d-flex justify-end `}>
                                                        <div className={`w-p-100 d-flex justify-center align-center`}>
                                                            <Avatar ImgSrc={!!props.Icon ? props.Icon : ""} Name={props.Title} className={` d-flex justify-center align-center`} Size={30} />
                                                        </div>
                                                    </div>
                                                    }
                                                    <div className="live-chat-inboundmsg bg-color-secondary h5-medium t-align-left float-left p-1 mt-2 ml-1 w-p-60 w-break w-fill">
                                                        {props.StepData?.WelcomeMessage}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className={`w-p-100 d-flex justify-center flex-direction align-center bg-color-secondary`} >
                                    {widgetLoginType === VisitorLoginType.ALLOW_ANONYMOUS_LOGIN_ONLY &&
                                        <div className={` w-p-100 d-flex align-center pt-2 bg-color-secondary  ${props.StepData.IsAllowFalkonBranding ? "" : "pb-2"}`}>
                                            <div className={`w-p-74 min-h-5 max-h-5 box-shadow-live-chat-input h5-medium br-1 color-secondary m-auto d-flex align-center  justify-center c-pointer`} style={{ background: props?.StepData?.WidgetColor }} onClick={() => { }}>
                                                {"Chat"}
                                            </div>
                                        </div>
                                    }
                                    {props.StepData.IsAllowFalkonBranding && <div className="d-flex w-p-100 min-h-6 justify-center align-center">
                                        <LiveChatByFalkonSystemsIcon className={"w-2 h-2"} />
                                        <span className="d-flex align-center justify-center h-p-100 live-chat-footer color-live-chat-anonymous">&nbsp;Powered by&nbsp;&nbsp;<a href="https://www.falkonsystems.com/" target="_blank" style={{ color: "#3663ff", textDecoration: "none" }}>Falkon Systems</a>
                                            &nbsp;&&nbsp;<a href="https://www.falkonsms.com/" target="_blank" style={{ color: "#3663ff", textDecoration: "none" }}>Falkon SMS</a>
                                        </span>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )

}


export default VisitorDetailsComponent;